export default __webpack_public_path__ + "content/media/30.5cbb5b4d.jpg";